import { Bug, Heart } from "lucide-react";
import { Link } from "react-router-dom";

export default function AppFooter() {
  const feedback = () => {
    void import("@sentry/react").then((Sentry) => {
      const message = window.prompt("What went wrong, or what would make the game better?");
      if (message?.trim()) Sentry.captureFeedback({ message: message.trim() });
    });
  };
  return (
    <footer className="site-footer">
      <p>Made for clever friends <Heart size={15} fill="currentColor" aria-hidden="true" /></p>
      <nav aria-label="Footer"><Link to="/settings">Privacy & settings</Link><button type="button" onClick={feedback}><Bug size={15} /> Report a problem</button></nav>
    </footer>
  );
}
